
import { Component, Prop, Ref, Vue } from 'nuxt-property-decorator';
import {
  rem,
  speakerLayoutModifiersMap,
  SpeakersBlockLayout,
  SpeakersBlockListItemModel,
  SpeakersBlockSettingsModel,
} from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import {
  contentBlockImageSizeModifiersMap,
  contentBlockTextVerticalAlignmentModifiersMap,
} from 'fourwaves-shared/src/services';
import ContentBlockImage from '../ContentBlockImage.vue';
import SpeakerBioModal from './SpeakerBioModal.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockImage,
    SpeakerBioModal,
  },
})
export default class SpeakersBlockListItem extends Vue {
  @Prop({ type: Object, required: true }) readonly item!: SpeakersBlockListItemModel;
  @Prop({ type: Object, required: true }) readonly settings!: SpeakersBlockSettingsModel;

  @Ref() readonly speakerBioModal?: SpeakerBioModal;

  get aspectRatio(): number {
    return this.isCardLayout ? 3 / 2 : 1 / 1;
  }

  get borderRadius(): string {
    return this.isCardLayout ? `${rem(12)} ${rem(12)} 0 0` : (rem(12) ?? '');
  }

  get isCardLayout(): boolean {
    return this.settings.layout === SpeakersBlockLayout.Card;
  }

  get itemClassNames(): string[] {
    return [
      contentBlockImageSizeModifiersMap[this.settings.imageSize],
      contentBlockTextVerticalAlignmentModifiersMap[this.settings.textVerticalAlignment],
      speakerLayoutModifiersMap[this.settings.layout],
    ];
  }

  public openBioModal() {
    this.speakerBioModal?.open();
  }
}
